<template>
  <div>
    <component
      :is="Form"
      :role-type="roleType"
      :loading-next="loadingNext"
      @prev="$emit(StepDirection.PREV, $event)"
      @next="$emit(StepDirection.NEXT, $event)"
    ></component>
  </div>
</template>

<script>
import { ServicesModule } from '@/store/modules/services';
import { isMrpaEnable } from '@/app.config';
import { ApplicantRoleConst } from '@/constants';
import { StatementType, StepDirection } from '@/types/services';
// TODO: возможно куча импортов в одном файле увеличивает размер бандла
import Manual from '@/components/services/ExtractionRod/Applicant/Manual';
import { Machine } from '@/components/services/ExtractionRod/Applicant/Machine';
import MachineRod from '@/components/services/ROD/StepApplicant/Machine/Machine';
import ManualRod from '@/components/services/ROD/StepApplicant/Manual/Manual';

const ManualForm = {
  [StatementType.EXTRACTION_ROD]: Manual,
  [StatementType.ROD]: ManualRod,
};

const MachineForm = {
  [StatementType.EXTRACTION_ROD]: Machine,
  [StatementType.ROD]: MachineRod,
};

export default {
  name: 'MrpaSubject',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      StepDirection,
    };
  },
  computed: {
    manualVisible() {
      return !isMrpaEnable(this.statementType) || !this.isMachineFill;
    },

    Form() {
      return this.manualVisible
        ? ManualForm[this.statementType]
        : MachineForm[this.statementType];
    },

    isMachineFill() {
      const applicantRole = ServicesModule.statement.applicantRole;

      return (
        isMrpaEnable(this.statementType) &&
        applicantRole &&
        applicantRole === ApplicantRoleConst.TRUSTEE
      );
    },
  },
};
</script>
